import type { Integrations } from "./integrations";
import type { KomboJobState } from "./kombo_job_state";

export class KomboJobStates extends Array<KomboJobState> {
  constructor(jobStates?: KomboJobState[]) {
    super();
    if (jobStates instanceof Array)
      jobStates.forEach((jobState) => this.push(jobState));
  }

  public filterForPlatformSpecifics(
    integrations: Integrations,
  ): KomboJobStates {
    const integrationMap = integrations.reduce(
      (acc, integration) => {
        acc[integration.id] = integration;
        return acc;
      },
      {} as Record<string, Integrations[number]>,
    );

    return new KomboJobStates(
      this.filter((jobState) => {
        const integration = integrationMap[jobState.integration_id];
        if (integration?.provider !== "ukgpro") return true;
        console.trace(`Filtering out UKG Pro job: ${jobState}`);
        return !jobState.remote_id?.includes(":");
      }),
    );
  }

  public queryBy(query: string): KomboJobStates {
    return new KomboJobStates(
      this.filter((jobState) => {
        return jobState.query(query);
      }),
    );
  }

  public filterByLocation(locations: string[]): KomboJobStates {
    if (locations.length === 0) {
      return this;
    }
    return new KomboJobStates(
      this.filter((jobState) => {
        return locations.includes(jobState.location ?? "");
      }),
    );
  }

  public sortBy(
    propertyName: keyof KomboJobState,
    direction: "asc" | "desc" = "asc",
  ): KomboJobStates {
    const factor = direction === "asc" ? 1 : -1;

    return new KomboJobStates(
      [...this].sort((a, b) => {
        const aValue = a[propertyName];
        const bValue = b[propertyName];

        if (aValue instanceof Date && bValue instanceof Date) {
          return (aValue.getTime() - bValue.getTime()) * factor;
        } else if (typeof aValue === "string" && typeof bValue === "string") {
          return aValue.localeCompare(bValue) * factor;
        } else if (typeof aValue === "number" && typeof bValue === "number") {
          return (aValue - bValue) * factor;
        } else if (typeof aValue === "boolean" && typeof bValue === "boolean") {
          return (aValue === bValue ? 0 : aValue ? 1 : -1) * factor;
        } else if (aValue === null || aValue === undefined) {
          return factor;
        } else if (bValue === null || bValue === undefined) {
          return -factor;
        } else {
          return 0;
        }
      }),
    );
  }
}
